import { useRef } from "react";
import { MediaLibCategoryEnum, MediaPanelTabEnum } from "../../types";
import { useMediaLibPanelStoreShallow } from "../main-panel";
import { UploadBtnContainer } from "./upload-btn-container";

interface IProps {
  setSelectedTab: (value: MediaPanelTabEnum) => void;
}

export const UploadBtn = ({ setSelectedTab }: IProps) => {
  "use no memo";
  const controller = useRef(new AbortController());
  const {
    setFiles,
    setMediaLibFolderId,
    setMediaLibCategory,
    selectedFolderId,
    isBrandAssets,
    setSearchQuery,
  } = useMediaLibPanelStoreShallow((s) => ({
    setSearchQuery: s.setSearchQuery,
    setFiles: s.setFiles,
    setMediaLibCategory: s.setCategory,
    setMediaLibFolderId: s.setSelectedFolderId,
    selectedFolderId: s.selectedFolderId,
    isBrandAssets: s.category === MediaLibCategoryEnum.BrandAssets,
  }));

  return (
    <UploadBtnContainer
      onCleanSearch={() => setSearchQuery("")}
      onUploadStart={() => {
        setSelectedTab(MediaPanelTabEnum.MediaLib);
      }}
      setCategory={setMediaLibCategory}
      setSelectedFolderId={setMediaLibFolderId}
      onAddFiles={(files) => setFiles({ files, extend: true })}
      controller={controller.current}
      moveToCategory={
        isBrandAssets
          ? MediaLibCategoryEnum.BrandAssets
          : MediaLibCategoryEnum.AllFiles
      }
      selectedFolderId={
        isBrandAssets
          ? selectedFolderId ?? MediaLibCategoryEnum.BrandAssets
          : selectedFolderId
      }
    />
  );
};
